module.exports = __webpack_public_path__ + "media/src/assets/images/simulation-pic-42f6c3b87077a9285ef6312335ea9480.png";